import { MonitorSmartphone, Phone, Mail, MessageCircle, ArrowUp } from "lucide-react";
import { CONTACTS, IMAGES, scrollToId } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative text-paper pt-16 pb-8 grain overflow-hidden">
    <img
      src={IMAGES.server}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-night/[0.92]" aria-hidden="true" />
    <div className="absolute inset-0 bg-gradient-to-t from-night via-night/60 to-night/30" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-paper/10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 rounded-lg bg-copper text-white flex items-center justify-center">
              <MonitorSmartphone size={18} />
            </span>
            <span className="font-display font-bold text-lg">Monte PC <span className="text-copper">Service</span></span>
          </div>
          <p className="text-sm text-paper/55 leading-relaxed max-w-xs">
            Assistenza informatica artigianale ad Empoli e dintorni. Oltre vent'anni di esperienza al servizio di privati e aziende.
          </p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-paper/45 mb-4">Navigazione</p>
          <div className="flex flex-col gap-2.5">
            {[["servizi", "Servizi"], ["preventivo", "Simulatore"], ["chi-sono", "Chi Sono"], ["contatti", "Contatti"]].map(([id, label]) => (
              <button key={id} data-testid={`footer-${id}-link`} onClick={() => scrollToId(id)} className="text-left text-sm text-paper/70 hover:text-copper transition-colors duration-300 w-fit">
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-paper/45 mb-4">Recapiti</p>
          <div className="flex flex-col gap-3">
            <a data-testid="footer-email-link" href={`mailto:${CONTACTS.email}`} className="flex items-center gap-2.5 text-sm text-paper/70 hover:text-copper transition-colors duration-300">
              <Mail size={14} /> {CONTACTS.email}
            </a>
            <a data-testid="footer-phone-link" href={CONTACTS.phoneFixedHref} className="flex items-center gap-2.5 text-sm text-paper/70 hover:text-copper transition-colors duration-300">
              <Phone size={14} /> {CONTACTS.phoneFixed}
            </a>
            <a data-testid="footer-whatsapp-link" href={CONTACTS.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-sm text-paper/70 hover:text-copper transition-colors duration-300">
              <MessageCircle size={14} /> {CONTACTS.mobile} (WhatsApp)
            </a>
          </div>
        </div>
      </div>
      <div className="pt-7 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-mono text-[11px] text-paper/40 tracking-wide">© 2026 Monte PC Service · Tutti i diritti riservati</p>
        <button
          data-testid="footer-back-to-top-button"
          onClick={() => (window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" }))}
          className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-paper/50 hover:text-copper transition-colors duration-300"
        >
          Torna su <ArrowUp size={13} />
        </button>
      </div>
    </div>
  </footer>
);
